{
  "title": "Fortune's Favor",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "2nd-level divination (dunamancy)",
  "level": 2,
  "castingTime": "1 minute",
  "range": "60 feet",
  "components": "V, S, M (a white pearl worth at least 100 gp, which the spell consumes)",
  "duration": "1 hour",
  "description": [
    "You impart latent luck to yourself or one willing creature you can see within range. When the chosen creature makes an attack roll, an ability check, or a saving throw before the spell ends, it can dismiss this spell on itself to roll an additional d20 and choose which of the d20s to use. Alternatively, when an attack roll is made against the chosen creature, it can dismiss this spell on itself to roll a d20 and choose which of the d20s to use, the one it rolled or the one the attacker rolled.",
    "If the original d20 roll has advantage or disadvantage, the creature rolls the additional d20 after advantage or disadvantage has been applied to the original roll.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can target one additional creature for each slot level above 2nd."
  ],
  "spellLists": ["wizard"]
}
